<main class="container">
  <section>
    <h2 i18n>Datenschutz</h2>
    <div class="card">
      <p i18n>Wir nehmen den Schutz Ihrer persönlichen Daten ernst. Personenbezogene Daten werden vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften behandelt.</p>
      <p i18n>Beim Besuch dieser Website werden keine personenbezogenen Daten ohne Ihre ausdrückliche Zustimmung gespeichert, außer technisch notwendigen Daten (Server-Logs).</p>
      <p i18n>Für Kontaktanfragen werden die von Ihnen angegebenen Informationen ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.</p>
      <p i18n>Bei Fragen zum Datenschutz wenden Sie sich bitte an: info@emzoll.de</p>
    </div>
  </section>
</main>